/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { RecordStringUnknown } from './recordStringUnknown'

/**
 * 追加設定。SURVEYノードは routing config { routingQuestionId?, routing?, defaultTargetNodeKey } を持つ（#263: defaultTargetNodeKey / #265: routingQuestionId+routing で回答分岐・ADR-0011）
 * @nullable
 */
export type ScenarioNodeConfig = RecordStringUnknown | null
